import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BasketClientComponent } from './basket-client/basket-client.component';
import { SharedModule } from '../shared/shared.module';
import { BasketAdminComponent } from './basket-admin/basket-admin.component';
import { OfflineBasketComponent } from '../shared/offline-basket/offline-basket.component';
import { BasketOfflineComponent } from './basket-offline/basket-offline.component';



@NgModule({
  declarations: [
    BasketClientComponent,
    BasketAdminComponent,
    OfflineBasketComponent,
    BasketOfflineComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    SharedModule
  ]
})
export class BasketModule { }
